module.exports = __webpack_public_path__ + "static/media/41.b22c9078.svg";